// extracted by mini-css-extract-plugin
export var section = "FAQ-module--section--b87a9";
export var sectionTitle = "FAQ-module--sectionTitle--d7a79";